module.exports = __webpack_public_path__ + "static/media/3DPPA30.f431172b.jpg";